var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "rating-row align-center",
      class: _vm.pill
        ? "rating-row--pill d-inline-flex align-center gc-3 rounded-20 border-sm pa-3"
        : ["d-flex ga-2 flex-wrap", _vm.centered && "w-100 justify-center"],
      attrs: { "data-qa": "stars_rating_row" },
    },
    [
      _vm.pill
        ? [
            _c(
              "div",
              { staticClass: "d-flex align-center gc-1 flex-shrink-0" },
              [
                _c("span", {
                  staticClass:
                    "ui-icon-rating-star-filled ui-icon-fz-medium rating--text flex-shrink-0",
                  attrs: { "data-qa": "stars_rate" },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "text-subtitle-1 text--text text-no-wrap" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.formatRatingScore(_vm.solidity)) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ]
        : _c(_setup.RatingBadge, { attrs: { solidity: _vm.solidity } }),
      _vm._v(" "),
      _vm.reviewsHref
        ? _c(
            "a",
            {
              staticClass:
                "rating-row__reviews primary--text text-decoration-none link-decoration-none text-no-wrap",
              class: _vm.pill ? "text-body-1" : "text-body-2",
              attrs: {
                "data-qa": "stars_rating_reviews_link",
                href: _vm.reviewsHref,
              },
            },
            [
              _setup.reviewsCount > 0
                ? [
                    _vm._v(
                      "\n      " +
                        _vm._s(_setup.formattedReviewsCount) +
                        " " +
                        _vm._s(_setup.reviewsLabel) +
                        "\n    "
                    ),
                  ]
                : [
                    _vm._v(
                      "\n      " + _vm._s(_setup.noReviewsLabel) + "\n    "
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }